import { getObjectURL } from '../../util/file';
import * as actionTypes from './actionType';
import join from 'url-join';
import { ApiServerUrl } from '../../config.json';
import { fromJS } from 'immutable';

export const initialState = fromJS({
    request_finishing_retainerOptA: '0', // 0 Set of Retainers,1 Bleacing Tray
    request_finishing_retainerOptB: '0', // 0 use latest treatment plan, 1 update new stl files
    tab: '0', //selected tab
});

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FINISHING_RETAINER_SELECT_OPTION:
            state = state.update('request_finishing_retainerOptA', (value) => action.payload);
            return state;
        case actionTypes.FINISHING_RETAINER_IMPRESSION_SELECT_OPTION:
            state = state.update('request_finishing_retainerOptB', (value) => action.payload);
            return state;

        case actionTypes.FINISHING_RETAINER_CHANGE_TAB:
            state = state.update('tab', (value) => action.payload);
            return state;

        default:
            return state;
    }
};

export default reducer;
